import React, { createContext } from 'react'
import PropTypes from 'prop-types'
import usePartner from '../../hooks/usePartner'

export const initialContext = {
  isEnabled: false,
  isSignedIn: false,
  firstName: null,
  membershipName: null,
  membershipNumber: null,
  points: null,
  pointsName: null,
  onlineAuthCode: null,
  offlineAuthCode: null
}

export const SSOContext = createContext(initialContext)

function SSOProvider ({ isEnabled, children }) {
  const ssoConfig = usePartner('config.sso')

  // if (isEnabled) {
  // todo: fetch additional information from the place we decide upon once redirect server is setup
  // }

  const props = {
    isEnabled,
    ...ssoConfig
  }

  return <SSOContext.Provider value={props}>{children}</SSOContext.Provider>
}

SSOProvider.displayName = 'SSOProvider'

SSOProvider.propTypes = {
  isEnabled: PropTypes.bool,
  children: PropTypes.node
}

export default SSOProvider
